const defaultObj = {
	attribute: '',
	calc: '',
	characterNumber: 0,
	col: 0,
	description: '',
	dot: 0,
	format: null,
	formsKeyboardFieldsId: null,
	formsRepositoryId: 0,
	formsSnippetDescription: '',
	formsSnippetsId: 0,
	id: 0,
	impactType: null,
	justify: null,
	keyboardPrompt: '',
	order: 0,
	row: 0,
	staticValue: '',
	truncate: null,
	canBeUpdated: false
};
export default obj => {
	return Object.assign({}, defaultObj, obj);
};
